import styled from 'styled-components';
import { Flex, UnorderedList } from '@chakra-ui/react';

export const Sbutton = styled.button`
  color: #0094ff;
  font-weight: 700;
  &:hover {
    text-decoration-line: underline;
  }
`;

export const FlexCheckBox = styled(Flex)`
  .chakra-checkbox__label {
    height: auto;
  }
`;

export const Ul = styled(UnorderedList)`
  list-style-position: inside;
  text-indent: 1rem;

  .circle {
    list-style-type: circle;

    &.circle:nth-of-type(3) {
      display: inline-block;
    }
  }
`;
